import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  message,
} from "antd";
import {FormInstance} from "antd/lib/form/Form";
import React, {useContext, useEffect, useRef, useState} from "react";

import type {InputRef} from "antd";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {catalogService, pharmacyStoreService} from "api";

import moment from "moment";
import InputCode from "components/common/Code/Code";
import {
  setListLoOfName,
  setListUnitOfThuocId,
} from "redux/reducer/medicineStore";
type EditableRowProps = {
  index: number;
};
const {INPUT, SELECT, NUMBER, DATE, AUTO_COMPLETE, COMBO_BOX, CURRENCY, CODE} =
  FIELD_TYPE;
export type EditableCellProps = {
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;
  handleSave: (record, index) => void;
  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  rules?: any;
  hidden?: boolean;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
  const [form] = Form.useForm();

  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  hidden,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;
  const [inputValue, setInputValue] = useState({});
  const [newOptions, setNewOptions] = useState(options);
  const [optionsUnit, setOptionsInit] = useState();

  const [max, setMax] = useState(null);
  const [rules, setRules] = useState([]);

  const handleSetFieldValue = (dataIndex, value) => {
    form.setFieldValue(dataIndex, value);
    setInputValue({...inputValue, [dataIndex]: value});
    handleSave(form.getFieldsValue(), index);
  };
  // const setSoLuongNhap = async () => {
  //   const detailLo = await getDetailLo(form.getFieldValue("soLo"));

  //   const tonKho = detailLo.tonKho;
  //   // console.log(tonKho);
  //   // setMaxQuantitySale(detailLo.tonKho);
  //   if (soLuongKe > tonKho) {
  //     handleSetFieldValue("soLuongNhap", tonKho);
  //     // form.setFieldValue("soLuongNhap", tonKho);
  //   } else {
  //     handleSetFieldValue("soLuongNhap", soLuongKe);
  //   }
  //   setTongTien();
  // };
  useEffect(() => {
    setListUnit();
  }, []);

  useEffect(() => {
    inputRef.current?.focus();
  }, [editing]);
  const setListUnit = async () => {
    const listUnit = await getListUnit();
    if (dataIndex == "donViChuyenDoi") {
      setNewOptions(listUnit.data.map(e => ({value: e.id, label: e.name})));
    }
  };
  const getListUnit = async () => {
    try {
      const res = await catalogService.getListUnit();
      return res;
    } catch (error) {
      return [];
    }
  };
  let childNode = children;

  if (type == INPUT) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]}
        rules={rules}
      >
        <Input
          disabled={disabled}
          onChange={async e => {
            setInputValue({...inputValue, [dataIndex]: e.target.value});
            handleSave(form.getFieldsValue(), index);
          }}
          ref={inputRef}
        ></Input>
      </Form.Item>
    );
  }
  if (type == DATE) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex] ? moment(record[dataIndex]) : null}
      >
        <DatePicker
          disabled={disabled}
          onChange={() => {
            handleSave(form.getFieldsValue(), index);
          }}
          format={FORMAT_TIME.dayFull as string}
        ></DatePicker>
      </Form.Item>
    );
  }
  if (type == NUMBER) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]}
        rules={rules}
      >
        <InputNumber
          disabled={disabled}
          onChange={e => {
            setInputValue({...inputValue, [dataIndex]: e});
            handleSave(form.getFieldsValue(), index);
          }}
          max={max}
          {...restProps}
        ></InputNumber>
      </Form.Item>
    );
  }
  if (type == AUTO_COMPLETE) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]}
        rules={rules}
      >
        <AutoComplete
          showSearch
          allowClear
          notFoundContent={null}
          value={value}
          defaultActiveFirstOption={false}
          filterOption={(inputValue, option) =>
            option?.label
              .toString()
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
          options={newOptions}
          disabled={disabled}
          {...restProps}
          onChange={async e => {
            setInputValue({...inputValue, [dataIndex]: e});
            handleSave(form.getFieldsValue(), index);

            // lay list so lo
          }}
        ></AutoComplete>
      </Form.Item>
    );
  }
  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{margin: 0}}
        name={dataIndex}
        initialValue={record[dataIndex]}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          placeholder={"Chọn"}
          options={newOptions}
          disabled={disabled}
          allowClear={true}
          onChange={e => {
            setInputValue({...inputValue, [dataIndex]: e.value});
            handleSave(form.getFieldsValue(), index);
          }}
          {...restProps}
        />
      </Form.Item>
    );
  }
  if (type == CURRENCY) {
    childNode = (
      <Form.Item name={dataIndex} initialValue={record[dataIndex]}>
        <InputNumber
          disabled={disabled}
          defaultValue={value}
          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={value => value!.replace(/\$\s?|(,*)/g, "")}
          onChange={e => {
            setInputValue({...inputValue, [dataIndex]: e.value});
            handleSave(form.getFieldsValue(), index);
          }}
          placeholder={"Nhập"}
          addonAfter="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }
  if (type == CODE) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]?.toString().toUpperCase()}
      >
        <InputCode
          // {...props}
          value={value?.toString().toUpperCase()}
          placeholder={"Nhập"}
          onChange={e => {
            if (onChange) {
              onChange(e);
            }
            setInputValue({
              ...inputValue,
              [dataIndex]: e.target.value.toString().toUpperCase(),
            });
            handleSave(form.getFieldsValue(), index);
          }}
        ></InputCode>
      </Form.Item>
    );
  }
  if (selected) {
    childNode = (
      <Form.Item
        style={{margin: 0}}
        name={dataIndex}
        initialValue={record[dataIndex]}
      >
        <Select
          disabled={disabled}
          allowClear
          showSearch
          placeholder="Chọn"
          options={dataIndex == "donviTinh" ? optionsUnit : options}
          onChange={e => {
            if (dataIndex == "thuocId") {
            }
            setInputValue({...inputValue, [dataIndex]: e});
            handleSave(form.getFieldsValue(), index);
          }}
        />
      </Form.Item>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
